// Visibilite du pilier « Conseil » (accompagnement Horiz Conseil sur WhatsApp).
//
// Decision Charly du 03/11/2026 : visible pour TOUT LE MONDE, sauf les comptes Pro.
// L'offre a 47 EUR s'adresse aux bailleurs particuliers ; une agence qui la verrait
// serait orientee vers une offre qui ne lui correspond pas.
//
// Ce n'est PAS un controle d'abonnement : l'entree est visible meme pour un compte
// gratuit, qui arrive alors sur la page de presentation de l'offre. Le numero WhatsApp,
// lui, reste reserve aux abonnes (voir components/Onboarding/conseilAccess.js).
//
// Fail-closed : un profil Keycloak illisible n'affiche rien, comme les autres gardes.
export function isConseilMenuEnabled() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  const rp = (tp && tp.rl_profile) || null
  if (!rp) {
    return false
  }

  // rl_profile.isPro est une CHAINE ('true' / 'false'), comme dans stores/user.js.
  return rp.isPro !== 'true'
}
